import { render, staticRenderFns } from "./cangku.vue?vue&type=template&id=3e6fd5a2&scoped=true&"
import script from "./cangku.vue?vue&type=script&lang=js&"
export * from "./cangku.vue?vue&type=script&lang=js&"
import style0 from "./cangku.vue?vue&type=style&index=0&id=3e6fd5a2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6fd5a2",
  null
  
)

export default component.exports